<template>
  <div v-if="isLogged" class="c-user__avatar-component">
    <a v-if="user && avatarUrl" :href="`/profile/${user?.username}/`" class="c-header__link">
      <div class="c-user__avatar-container">
        <SVGIcon class="c-user__avatar-border" width="48" height="48" name="avatar-outline-thick" />
        <img :src="avatarUrl" alt="" class="c-avatar__image">
        <SVGIcon v-if="hasActiveMembership" class="c-user__avatar-premium-icon" name="diamond-small" />
      </div>
    </a>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from 'vue'
import { User, getUser } from '@/utils/api'
import { useAuth } from '@/utils/auth'
import SVGIcon from '@/components/SVGIcon.vue'

const { isLogged, user } = useAuth()
const userData = ref<User>()
const avatarUrl = ref('')

const hasActiveMembership = ref(false)

watch([ isLogged, user ], async () => {
  console.log('isLogged: ', isLogged.value)
  console.log('user: ', user.value)

  if (user.value) {
    userData.value = await getUser(user.value.pk!)
    // console.log('userData: ', userData.value)
    avatarUrl.value = userData.value.forum_user.avatar_url
    // console.log('avatarUrl: ', avatarUrl.value)
    hasActiveMembership.value = userData.value.forum_user.is_premium
    // console.log('hasActiveMembership: ', userData.value)
  }
}, { immediate: true })

onMounted(async () => {

})
</script>

<style scoped lang="scss">
.c-user__avatar-component {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  margin-right: 1rem;
}

.c-user__avatar-container {
  display: flex;
  flex-direction: row;
  width: 48px;
  height: 48px;
}

.c-user__avatar-border {
  position: absolute;
}

.c-user__avatar-premium-icon {
  position: relative;
  left: 68%;
  top: -8px;
}

.c-avatar__image {
  flex: 0 0 auto;
  width: 48px;
  height: 48px;
  max-width: 48px;
  max-height: 48px;
  margin-right: 10px;
  position: absolute;
  border-radius: 20px;
  z-index: -1;
}

.c-header__user-avatar {
  .c-avatar__image {
    border-radius: 18px;
  }
}
</style>
